import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient, } from "@angular/common/http";
import { GlobalComponent } from "../../global/global.component";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FilterSettingsModel, IFilter, GridComponent, DataStateChangeEventArgs, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { SearchSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { ServiceList, sortingObj, DropList, functionpermission, ServiceGroupMappingBO, GetMSListBo, GetSGBO, PaylocityBO, WhereCondition, GetMAListBo, GetMSAListBo, ActivityList, ServiceActivityList, columnWidth, ColumnChangeBO, GetListBO, ServiceGroupBO, GetPLCListBo, GroupServiceMapBO, QpServicesList, LovDropDownBO } from './manage.model';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonApiService } from 'src/app/commonapiservice';
import { ManageService } from './manage.service';
import { GeneralService } from 'src/app/service/general.service';
import { EmployeeService } from '../employee/employee.service';

@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.scss'],
})
export class ManageComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  selectedtab: string = "Service";
  ServiceArray: ServiceList[];
  Service: ServiceList = new ServiceList();
  Activity: ActivityList = new ActivityList();
  ServiceActivity: ServiceActivityList = new ServiceActivityList();
  StatusList: LovDropDownBO[];
  FilterStatusDropDown: LovDropDownBO[];
  MSsendBO: GetMSListBo = new GetMSListBo();
  MSsendBO1: GetMAListBo = new GetMAListBo();
  MSsendBO2: GetMSAListBo = new GetMSAListBo();
  PLsendBO: GetPLCListBo = new GetPLCListBo();
  SGsendBO: GetSGBO = new GetSGBO();
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();
  ColumnArray_service: columnWidth[]
  ColumnArray_activity: columnWidth[]
  ColumnArray_serviceactivity: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: string;
  arraycol: any = [];
  ServiceGroupSendBO: GetListBO = new GetListBO();
  ServiceGroup: any = new ServiceGroupBO();
  ServiceGroupBool: boolean = false;
  defaultServicesDropdown: any = [];
  defaultServicesDropdown1: any = [];
  ServiceGroupDrop: any = [];
  paylocity: any = new PaylocityBO();
  ServiceGroupMapping: any = new ServiceGroupMappingBO();
  ActivityBool: boolean = false;
  ServiceActivityBool: boolean = false;
  ServicePalocityBool: boolean = false;
  ServiceGrpMapBool: boolean = false;
  AssignQpSerBool: boolean = false;
  selectedServiceID: string;
  availableActivities: any = [];
  selectedActivities: any = [];
  ServiceDataList: any = [];
  ServiceForm: FormGroup;
  ActivityForm: FormGroup;
  ServiceGroupForm: FormGroup;
  PaylocityForm: FormGroup;
  ServiceGroupMappingForm: FormGroup;
  dropInstance: DropDownList;
  public searchSettings: SearchSettingsModel;
  public toolbar: ToolbarItems[];
  initialPage: object;
  filterOptions: FilterSettingsModel;
  @ViewChild('gridServiceGroup') public gridServiceGroup: GridComponent;
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('gridactivity') public gridactivity: GridComponent;
  @ViewChild('gridserviceactivity') public gridserviceactivity: GridComponent;
  @ViewChild('PLgrid') public PLgrid: GridComponent;
  @ViewChild('SGMgrid') public SGMgrid: GridComponent;
  filter: IFilter;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public isinitialLoad: boolean = false;
  ErrorList: any = [];
  public GridDataList: Observable<DataStateChangeEventArgs>;
  public GridSGMDataList: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  filterSelect_service: string;
  pagshort: sortingObj = new sortingObj();
  ModalType: string;
  ServiceActivityArray1: any = [];
  ServiceGroupDataList: any = [];
  ServicePalocityArray: any = [];
  ServiceDataActivityList: any = [];
  PLDataList: any = [];
  SGMDataList: any = [];
  ShowStatus: boolean = false;
  groupId: number;
  fp: functionpermission;
  ServiceActivityArray: any = [];
  valuechangeService: any = [];
  DataActivityList: any = [];
  deleteAlert: boolean = false;
  deleteError: any = "";
  masterServiceId: any = [];
  QPServiceForm: FormGroup;
  type: string = "";
  isSaveorUpdateBoolean:boolean=false;
  QpServicesList: QpServicesList = new QpServicesList();
  constructor(public CommonAPI: CommonApiService, 
    private employeeService: EmployeeService,
    public http: HttpClient, private formBuilder: FormBuilder, public global: GlobalComponent, public toastrService: ToastrService, public general: GeneralService, public MS: ManageService,) {
    this.global.agencyList();
    this.GridDataList = CommonAPI;
    this.GridSGMDataList = MS;
    this.ServiceGroupForm = this.formBuilder.group({
      Name: [' ', Validators.required],
      DefaultService: [' ', Validators.required]
    });
    this.PaylocityForm = this.formBuilder.group({
      Name: [' ', Validators.required],
      DefaultService: [' ', Validators.required]
    });
    this.ServiceGroupMappingForm = this.formBuilder.group({
      GroupName: [' ', Validators.required],
      ServiceGroupMapping: [' ', Validators.required]
    });
    this.ServiceForm = this.formBuilder.group({
      Code: [' ', Validators.required],
      Modifier1: [' '],
      Modifier2: [' '],
      Modifier3: [' '],
      Modifier4: [' '],
      Name: ['', Validators.required],
      Description: ['', Validators.required],
      BillingUnit: [''],
      Status: ['', Validators.required],
      Ratio: ['', Validators.required],
      NetRate: ['', Validators.required],
      UnitRate: ['', Validators.required],
      is837I: [''],
      isHousing: ['']
    });
    this.ActivityForm = this.formBuilder.group({
      Code: [' ', Validators.required],
      Name: ['', Validators.required],
      Status: ['', Validators.required]
    });
    this.QPServiceForm = this.formBuilder.group({
      services: ['', Validators.required],

    });
  }
  ngOnInit() {
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == '00000000-0000-0000-0000-000000000000') {
      return;
    }
    this.ServiceGroupSendBO.currentpageno = 1;
    this.ServiceGroupSendBO.pageitem = 10;
    this.ServiceGroupSendBO.type = "number";
    this.ServiceGroupSendBO.field = "id";
    this.ServiceGroupSendBO.operator = "greaterthanorequal";
    this.ServiceGroupSendBO.value = "0";
    this.ServiceGroupSendBO.orderColumn = "id";
    this.ServiceGroupSendBO.orderType = "ASC";
    // this.getServiceGroup();
    this.getStatusDrop();
    this.getService();
    this.conditionlist.push(new WhereCondition());
    this.filterSelect_service = '00000000-0000-0000-0000-000000000000';
    this.fp = new functionpermission();
  
    this.getServiceType();
    // this.getServiceTypeSatus();
   // this.filepermissionget();
    this.toolbar = ['ColumnChooser'];
    this.filterOptions = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    //this.getColumnwidth();
  }
  //................................ dataStateChangeServiceGroup................................
  dataStateChangeServiceGroup(state) {
    let type = (state.action.requestType).toString();
    if (type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ServiceGroupSendBO.orderColumn = state.sorted[0].name;
        this.ServiceGroupSendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      if (this.ServiceGroupSendBO.type == "number") {
        this.ServiceGroupSendBO.value = state.action.currentFilterObject.value.toString();
        this.ServiceGroupSendBO.field = state.action.currentFilterObject.field;
      }
      if (this.ServiceGroupSendBO.type == "date") {
        this.ServiceGroupSendBO.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        this.ServiceGroupSendBO.field = state.action.currentFilterObject.field;
      }
      else {
        this.ServiceGroupSendBO.value = state.action.currentFilterObject.value.toString();
        this.ServiceGroupSendBO.field = state.action.currentFilterObject.field;
      }
      this.ServiceGroupSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ServiceGroupSendBO.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (type == "filtering" && state.action.action == "clearFilter") {
        this.ServiceGroupSendBO.currentpageno = 1;
        this.ServiceGroupSendBO.pageitem = 10;
        this.ServiceGroupSendBO.type = "number";
        this.ServiceGroupSendBO.field = "id";
        this.ServiceGroupSendBO.operator = "greaterthanorequal";
        this.ServiceGroupSendBO.value = "0";
        this.ServiceGroupSendBO.orderColumn = "id";
        this.ServiceGroupSendBO.orderType = "ASC";
      }
    }
    if (this.selectedtab == 'ServiceGroup') {
      this.getServiceGroup();
    }
  }
  // ................................dataStateChange................................
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.MSsendBO.orderColumn = state.sorted[0].name;
        this.MSsendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.MSsendBO.field = state.action.currentFilterObject.field;
      this.MSsendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.MSsendBO.operator = state.action.currentFilterObject.operator;
      this.MSsendBO.value = state.action.currentFilterObject.value.toString();
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.MSsendBO.field = "MasterServiceName";
        this.MSsendBO.matchCase = false;
        this.MSsendBO.operator = "startswith";
        this.MSsendBO.value = "";
        this.MSsendBO.type = "string";
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].ManageServices_ServiceTab.Pagesize != state.take) {
          this.arraycol[0].ManageServices_ServiceTab.Pagesize = state.take
        //  this.SaveColumnwidth();
        }
      }
    }
    if (this.selectedtab == 'Service') {
      this.getService();
    }
  }
  //................................ dataStateChange1................................
  public dataStateChange1(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.MSsendBO1.orderColumn = state.sorted[0].name;
        this.MSsendBO1.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.MSsendBO1.field = state.action.currentFilterObject.field;
      this.MSsendBO1.matchCase = state.action.currentFilterObject.matchCase;
      this.MSsendBO1.operator = state.action.currentFilterObject.operator;
      this.MSsendBO1.value = state.action.currentFilterObject.value.toString();
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.MSsendBO1.field = "MasterServiceName";
        this.MSsendBO1.matchCase = false;
        this.MSsendBO1.operator = "startswith";
        this.MSsendBO1.value = "";
        this.MSsendBO1.type = "string";
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].ManageServices_ActivityTab.Pagesize != state.take) {
          this.arraycol[0].ManageServices_ActivityTab.Pagesize = state.take
          //this.SaveColumnwidth();
        }
      }
    }
    if (this.selectedtab == 'Activity') {
      this.getActivity();
    }
  }
  // ................................dataStateChange2................................
  public dataStateChange2(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.MSsendBO2.orderColumn = state.sorted[0].name;
        this.MSsendBO2.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.MSsendBO2.field = state.action.currentFilterObject.field;
      this.MSsendBO2.matchCase = state.action.currentFilterObject.matchCase;
      this.MSsendBO2.operator = state.action.currentFilterObject.operator;
      this.MSsendBO2.value = state.action.currentFilterObject.value.toString();
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.MSsendBO2.field = "MasterServiceName";
        this.MSsendBO2.matchCase = false;
        this.MSsendBO2.operator = "startswith";
        this.MSsendBO2.value = "";
        this.MSsendBO2.type = "string";
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].ManageServices_ServiceActivityTab.Pagesize != state.take) {
          this.arraycol[0].ManageServices_ServiceActivityTab.Pagesize = state.take
        //  this.SaveColumnwidth();
        }
      }
    } if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].List.Pagesize != state.take) {
          this.arraycol[0].List.Pagesize = state.take
         // this.SaveColumnwidth();
        }
      }
    }
    if (this.selectedtab == 'Serviceactivity') {
      this.getServiceActivity();
    }
  }


  // ................................PLdataStateChange................................
  public PLdataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.PLsendBO.orderColumn = state.sorted[0].name;
        this.PLsendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.PLsendBO.field = state.action.currentFilterObject.field;
      this.PLsendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.PLsendBO.operator = state.action.currentFilterObject.operator;
      this.PLsendBO.value = state.action.currentFilterObject.value.toString();
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.PLsendBO.field = "Service";
        this.PLsendBO.matchCase = false;
        this.PLsendBO.operator = "startswith";
        this.PLsendBO.value = "";
        this.PLsendBO.type = "string";
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].List.Pagesize != state.take) {
          this.arraycol[0].List.Pagesize = state.take
          //this.SaveColumnwidth();
        }
      }
    }
    if (this.selectedtab == 'ServicePaylocity') {
      this.getPaylocity();
    }
  }
  // ................................SGdataStateChange................................
  public SGdataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.SGsendBO.orderColumn = state.sorted[0].name;
        this.SGsendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.SGsendBO.field = state.action.currentFilterObject.field;
      this.SGsendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.SGsendBO.operator = state.action.currentFilterObject.operator;
      this.SGsendBO.value = state.action.currentFilterObject.value.toString();
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.SGsendBO.field = "MasterServiceName";
        this.SGsendBO.matchCase = false;
        this.SGsendBO.operator = "startswith";
        this.SGsendBO.value = "";
        this.SGsendBO.type = "string";
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].ManageServices_ServiceActivityTab.Pagesize != state.take) {
          this.arraycol[0].ManageServices_ServiceActivityTab.Pagesize = state.take
         // this.SaveColumnwidth();
        }
      }
    }
    if (this.selectedtab == 'ServiceGrpMap') {
      this.getServcegroupMap();
    }
  }
  // ................................onActionCompleteServiceGroup................................
  onActionCompleteServiceGroup(args) {
    this.ServiceGroupSendBO.currentpageno = this.gridServiceGroup.pagerModule.pagerObj.currentPage;
    this.ServiceGroupSendBO.pageitem = this.gridServiceGroup.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.ServiceGroupSendBO.type = args.columnType;
    }
  }
  // ................................onActionCompletePL................................
  onActionCompletePL(args) {
    this.PLsendBO.currentpageno = this.PLgrid.pagerModule.pagerObj.currentPage;
    this.PLsendBO.pageitem = this.PLgrid.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.PLsendBO.type = args.columnType;
    }
  }
  // ................................onActionCompleteSG................................
  onActionCompleteSG(args) {
    this.SGsendBO.currentpageno = this.SGMgrid.pagerModule.pagerObj.currentPage;
    this.SGsendBO.pageitem = this.SGMgrid.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.SGsendBO.type = args.columnType;
    }
  }
  //................................ onActionComplete................................
  public onActionComplete(args) {

    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        this.arraycol[0].ManageServices_ServiceTab.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].ManageServices_ServiceTab.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (this.arraycol[0].ManageServices_ServiceTab.ShowColumns.length != count1 || this.arraycol[0].ManageServices_ServiceTab.HideColumns.length != count) {
          this.arraycol[0].ManageServices_ServiceTab.ShowColumns = showarr;
          this.arraycol[0].ManageServices_ServiceTab.HideColumns = hidearr;
         // this.SaveColumnwidth();
        }
      }
    }
    this.MSsendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.MSsendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.MSsendBO.type = args.columnType
    }
  }
  // ................................onActionComplete1................................
  public onActionComplete1(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridactivity.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        this.arraycol[0].ManageServices_ActivityTab.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].ManageServices_ActivityTab.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (this.arraycol[0].ManageServices_ActivityTab.ShowColumns.length != count1 || this.arraycol[0].ManageServices_ActivityTab.HideColumns.length != count) {
          this.arraycol[0].ManageServices_ActivityTab.ShowColumns = showarr;
          this.arraycol[0].ManageServices_ActivityTab.HideColumns = hidearr;
        //  this.SaveColumnwidth();
        }
      }
    }
    this.MSsendBO1.currentpageno = this.gridactivity.pagerModule.pagerObj.currentPage;
    this.MSsendBO1.pageitem = this.gridactivity.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.MSsendBO1.type = args.columnType
    }
  }
  // ................................onActionComplete2................................
  public onActionComplete2(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridserviceactivity.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        this.arraycol[0].ManageServices_ServiceActivityTab.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].ManageServices_ServiceActivityTab.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (this.arraycol[0].ManageServices_ServiceActivityTab.ShowColumns.length != count1 || this.arraycol[0].ManageServices_ServiceActivityTab.HideColumns.length != count) {
          this.arraycol[0].ManageServices_ServiceActivityTab.ShowColumns = showarr;
          this.arraycol[0].ManageServices_ServiceActivityTab.HideColumns = hidearr;
         // this.SaveColumnwidth();
        }
      }
    }
    this.MSsendBO2.currentpageno = this.gridserviceactivity.pagerModule.pagerObj.currentPage;
    this.MSsendBO2.pageitem = this.gridserviceactivity.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.MSsendBO2.type = args.columnType
    }
  }
  //===================================Show column settings===================//
  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50); 
  }
  showServiceGroup() {
    this.gridServiceGroup.columnChooserModule.openColumnChooser(200, 50); 
  }
  showactivity() {
    this.gridactivity.columnChooserModule.openColumnChooser(200, 50); 
  }
  showserviceact() {
    this.gridserviceactivity.columnChooserModule.openColumnChooser(200, 50); 
  }
  showPalocity() {
    this.PLgrid.columnChooserModule.openColumnChooser(200, 50); 
  }
  showServiceGroupMapping() {
    this.SGMgrid.columnChooserModule.openColumnChooser(200, 50); 
  }
  //................................ CreateupdateServiceGroup................................
  CreateupdateServiceGroup(type: string) {
    if (type == 'new') {
      this.ModalType = 'new';
      this.ServiceGroupForm.reset();
      this.ServiceGroup = new ServiceGroupBO();
      this.valueschangesServiceGroup();
    }
    else {

      this.valueschangesServiceGroup();
      this.ModalType = 'edit';

    }
  }
  // ................................Createupdate................................
  Createupdate(type: string) {
    if (type == 'new') {
      this.ModalType = 'new';
      this.ServiceForm.reset();
      //this.ServiceForm.controls.Status.setValue(1);
      this.Service = new ServiceList();
      this.Service.statusLid = '';
      this.valueschangesService();
      // this.Service.serviceTypeLid = this.global.serviceType ?.filter(
      //   (st) => st.Value == "HOMECARE"
      // )[0].Key;
    } else {
      this.valueschangesService();
      this.ModalType = 'edit';
    }
  }
  // ................................CreateupdateActivity................................
  CreateupdateActivity(type: string) {
    if (type == 'new') {
      this.ModalType = 'new';
      this.ActivityForm.reset();
      this.ActivityForm.controls.Status.setValue(1);
      this.Activity = new ActivityList();
      this.Activity.statusLid = '';
      this.valuchangesActivity();
    } else {
      this.valuchangesActivity();
      this.ModalType = 'edit';
    }
  }
  //................................ CreateupdateServiceActivity................................
  CreateupdateServiceActivity(type: string) {
    if (type == 'new') {
      this.ModalType = 'new';
      this.ServiceActivityArray1 = [];
      this.selectedActivities = [];
      this.availableActivities = [];
      this.valuchangesServiceActivity();
    } else {
      this.valuchangesServiceActivity();
      this.ModalType = 'edit';
    }
  }
  // ................................CreateupdateServicePaylocity................................
  CreateupdateServicePaylocity(type: string) {
    if (type == 'new') {
      this.ModalType = 'new';
      this.paylocity = new PaylocityBO();
      this.valuchangesServicePaylocity();
    } else {
      this.paylocity
      this.valuchangesServicePaylocity();
      this.ModalType = 'edit';
    }
  }
  // ................................CreateupdateGrpServiceMap................................
  CreateupdateGrpServiceMap(type: string) {
    if (type == 'new') {
      this.ModalType = 'new';
      this.ServiceGroupMapping = new ServiceGroupMappingBO();
      this.valuchangesServiceGrpMap();
      this.ServiceGroupMappingForm.get('GroupName').enable();
    } else {
      this.valuchangesServiceGrpMap();
      this.ModalType = 'edit';
      this.ServiceGroupMappingForm.get('GroupName').disable();
    }
  }
  //................................ selectServiceGroupDetails................................
  selectServiceGroupDetails(data: ServiceGroupBO) {
    this.ServiceGroup = JSON.parse(JSON.stringify(data));
    this.ServiceGroup.defaultMasterServiceId = this.ServiceGroup.defaultMasterServiceId.toString();
  }
  // ................................selectActivityDetails................................
  selectActivityDetails(data: ActivityList) {
    this.Activity = JSON.parse(JSON.stringify(data));
  }
  // ................................selectServiceActivityDetails................................
  selectServiceActivityDetails(data) {
    this.ServiceActivityArray1.masterServiceId = data.masterServiceId.toString();
    this.getActivityTypeSatus(this.ServiceActivityArray1.masterServiceId);
  }
  //................................ selectServicePaylocityDetails................................
  selectServicePaylocityDetails(data) {
    this.paylocity = JSON.parse(JSON.stringify(data));
    this.paylocity.masterServiceId = this.paylocity.masterServiceId.toString();
  }
  //................................ selectServiceGrpMap................................
  selectServiceGrpMap(data) {
    this.ServiceGroupMapping = JSON.parse(JSON.stringify(data));
  }
  //................................ serviceFilter................................
  serviceFilter(filter) {
    this.filterSelect_service = filter;
    if (this.filterSelect_service == '00000000-0000-0000-0000-000000000000') {
      this.ShowStatus = true;
    }
    this.getService();
  }
  //................................ ActivityFilter................................
  ActivityFilter(filter) {
    this.filterSelect_service = filter;
    if (this.filterSelect_service == '00000000-0000-0000-0000-000000000000') {
      this.ShowStatus = true;
    }
    this.getActivity();
  }
  // ................................ServiceActivityFilter................................
  ServiceActivityFilter(filter) {
    this.filterSelect_service = filter;
    if (this.filterSelect_service == '00000000-0000-0000-0000-000000000000') {
      this.ShowStatus = true;
    }
    this.getServiceActivity();
  }
  // ................................RefreshServiceGroup................................
  RefreshServiceGroup() {
    this.ServiceGroupSendBO.currentpageno = 1;
    this.ServiceGroupSendBO.pageitem = 10;
    this.ServiceGroupSendBO.type = "number";
    this.ServiceGroupSendBO.field = "id";
    this.ServiceGroupSendBO.operator = "greaterthanorequal";
    this.ServiceGroupSendBO.value = "0";
    this.ServiceGroupSendBO.orderColumn = "id";
    this.ServiceGroupSendBO.orderType = "ASC";
    this.getServiceGroup();
    this.gridServiceGroup.clearFiltering();
    this.gridServiceGroup.clearSorting();
  }
  //................................ Refresh................................
  Refresh() {
    this.MSsendBO.field = "MasterServiceName";
    this.MSsendBO.value = "";
    this.filterSelect_service = '';
    this.getService();
    this.grid.clearFiltering();
    this.grid.clearSorting();
  }
  // ................................RefreshActivity................................
  RefreshActivity() {
    this.MSsendBO1.field = "MasterActivityName";
    this.MSsendBO1.value = "";
    this.filterSelect_service = '';
    this.getActivity();
    this.gridactivity.clearFiltering();
    this.gridactivity.clearSorting();
  }
  // ................................RefreshServiceActivity................................
  RefreshServiceActivity() {
    this.MSsendBO2.field = "MasterServiceName";
    this.MSsendBO2.value = "";
    this.getServiceActivity();
    this.gridserviceactivity.clearFiltering();
    this.gridserviceactivity.clearSorting();
  }
  // ................................RefreshServicegrpmap................................
  RefreshServicegrpmap() {
    this.SGsendBO.field = "MasterServiceName";
    this.SGsendBO.value = "";
    this.SGsendBO.groupId = this.groupId;
    this.getServcegroupMap();
    this.SGMgrid.clearFiltering();
    this.SGMgrid.clearSorting();
  }
  // ................................RefreshPaylocity................................
  RefreshPaylocity() {
    this.PLsendBO.field = "Service";
    this.PLsendBO.value = "";
    this.getPaylocity();
    this.PLgrid.clearFiltering();
    this.PLgrid.clearSorting();
  }
  // ................................selectDetails................................
  selectDetails(ServiceDetails: ServiceList) {
    this.Service = JSON.parse(JSON.stringify(ServiceDetails));
  }
  //................................ getService................................
  getService() {
    let url = "api/Service/GetMasterServiceListFilter?"
    let responseData =
    {
      result: "msList",
      count: "totalCount",
    }
    this.MSsendBO.LovCode = this.filterSelect_service;
    this.CommonAPI.outputValues(url, this.MSsendBO, responseData, "");
    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ServiceDataList = data.result;
      if (data != null && data.result.length > 15) {
        this.grid.height = '500';
      }
      else {
        this.grid.height = 'auto';
      }
      if (data != null && data != undefined) {
      //  this.getColumnwidth();
      }
      data.result.forEach(element => {
        element.ratio = (element.ratio == null || element.ratio == undefined || element.ratio == 0) ? null : element.ratio;
      })
    })
  }
  //................................. gridServiceGroup............................
  getServiceGroup() {
    this.GetDefaultServicesDropDown1();
    let url = "api/ServiceGroup/GetServiceGroups";
    let responseData =
    {
      result: "result",
      count: "count",
    }
    this.CommonAPI.outputValues(url, this.ServiceGroupSendBO, responseData, "");
    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ServiceGroupDataList = data.result;
      if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
        if (data != null && data.result.length > 15) {
          this.gridServiceGroup.height = '500';
        }
        else {
          this.gridServiceGroup.height = 'auto';
        }
      }
    })
  }
  //........................................... gridactivity...........................................
  getActivity() {
  
    let url = "api/Activity/GetMasterActivityListFilter?"
    let responseData =
    {
      result: "maList",
      count: "totalCount",
    }
    this.MSsendBO1.LovCode = this.filterSelect_service;
    this.CommonAPI.outputValues(url, this.MSsendBO1, responseData, "");
    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.DataActivityList = data.result;
      if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
        if (data != null && data.result.length > 15) {
          this.gridactivity.height = '500';
        }
        else {
          this.gridactivity.height = 'auto';
        }
      }
    })
  }
  //.............................................gridserviceactivity.......................................
  getServiceActivity() {
    let url = "api/ServiceGroup/GetGroupServiceActivityList?"
    let responseData =
    {
      result: "msaList",
      count: "totalCount",
    }
    this.MSsendBO2.LovCode = this.filterSelect_service;
    this.CommonAPI.outputValues(url, this.MSsendBO2, responseData, "");
    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ServiceDataActivityList = data.result;
      if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
        if (data != null && data.result.length > 15) {
          this.gridserviceactivity.height = '500';
        }
        else {
          this.gridserviceactivity.height = 'auto';
        }
      }
    })
  }
  // ...........................................PLgrid...............................................................
  getPaylocity() {
    this.GetDefaultServicesDropDown1();
    this.PLsendBO.LovCode = this.filterSelect_service;
    let url = "api/Paylocity/GetPaylocityListFilter?"
    let responseData =
    {
      result: "paylocityList",
      count: "totalCount",
    }
    this.CommonAPI.outputValues(url, this.PLsendBO, responseData, "");
    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.PLDataList = data.result;
      if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
        if (data != null && data.result.length > 15) {
          this.PLgrid.height = '500';
        }
        else {
          this.PLgrid.height = 'auto';
        }
      }
    })
  }
  // ..................................................................SGMgrid..................................
  getServcegroupMap() {
    this.GetDefaultServicesDropDown1();
    this.GetServiceGroupDropDown();
    this.MS.outputValues(this.SGsendBO);
    this.GridSGMDataList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.SGMDataList = data.result;
      if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
        if (data != null && data.result.length > 15) {
          this.SGMgrid.height = '500';
        }
        else {
          this.SGMgrid.height = 'auto';
        }
      }
    })
  }
  // ..................................................................getServiceTypeSatus..................................
  getServiceTypeSatus() {
    let url = 'api/ServiceGroup/GetServiceGroupDropDown?'
    this.CommonAPI.getDropDownList('ServiceGroupDropDown', "", url, "SDD").then((data: any) => {
      this.ServiceActivityArray = data;
      this.ServiceActivityArray.forEach(element => {
        element.label = element.name;
        element.value = element.id.toString();
      })
    });

  }
  // ..................................................................getActivityTypeSatus..................................
  getActivityTypeSatus(serviceId) {
    let params = new URLSearchParams();
    params.append("serviceId", serviceId);
    let url = "api/ServiceActivity/getServiceActivityList?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.availableActivities = data.availableActivityPair;
      this.selectedActivities = data.selectedAcitivityPair;
    });
  }

   //..................................................getEmployeeStatus........................................
   getStatusDrop() {
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    this.employeeService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.StatusList = data;
      this.FilterStatusDropDown= data;
      let values =
      {
        "id": '00000000-0000-0000-0000-000000000000',
        "lovName": "ALL",
        "lovCode": "ALL",
        "lovValue": "ALL"
      }
      this.FilterStatusDropDown.push(values);
      this.filterSelect_service = this.FilterStatusDropDown?.filter(st => st.lovCode == "ALL")[0].id;
      // this.getEmployeeFilter();      
    })
  }
  // ..................................................................getStatusDrop..................................
  getStatusDrop1() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("Code", 'STATUS');
    this.CommonAPI.getDropDownList('STATUS', params, url, "LovDropDown").then((data: any) => {
      this.StatusList = data;

      this.FilterStatusDropDown = data;
      let values =
      {
        "id": null,
        "lovName": "ALL",
        "lovCode": "ALL",
        "lovValue": "ALL"
      }
    })
  }
  keypress(e) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(e.charCode);
    if (e.keyCode != 8 && !pattern.test(inputChar)) {
      e.preventDefault();
    }
    if (e.target.value.length == 0 && e.which == 48) {
      e.preventDefault();
      return false;
    }
  }
  // ..................................................................SaveOrUpdateServiceGroup..................................
  SaveOrUpdateServiceGroup(save) {
    this.isSaveorUpdateBoolean=true;
    if (this.ModalType == 'new') {
      this.ServiceGroup.id = '00000000-0000-0000-0000-000000000000';
    }
    let data = JSON.parse(JSON.stringify(save))
    data.defaultMasterServiceId = parseInt(data.defaultMasterServiceId.toString())
    let url = "api/ServiceGroup/SaveServiceGroup";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(data, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
   this.isSaveorUpdateBoolean=false;
      this.valueschangesServiceGroup();
      if (this.ModalType == 'new') {
        this.toastrService.success('Service Group saved successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.getServiceGroup();
        document.getElementById('openModal3').click();
      }
      else {
        this.toastrService.success('Service Group updated successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.getServiceGroup();
        document.getElementById('openModal3').click();
      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      this.toastrService.error(err, 'Error'), 8000;
    })
  }
  // ..................................................................SaveOrUpdateServicePaylocity..................................
  SaveOrUpdateServicePaylocity() {
    this.isSaveorUpdateBoolean=true;
    if (this.ModalType == 'new') {
      this.paylocity.id = '00000000-0000-0000-0000-000000000000';
    }
    let url = "api/Paylocity/SavePaylocity";
    this.paylocity.masterServiceId = parseInt(this.paylocity.masterServiceId.toString());
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.paylocity, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.valuchangesServicePaylocity();
      this.isSaveorUpdateBoolean=false;
      if (this.ModalType == 'new') {
        this.toastrService.success('Service Paylocity saved successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.getPaylocity();
        document.getElementById('openModal31').click();
      } else {
        this.toastrService.success('Service Paylocity updated successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.getPaylocity();
        document.getElementById('openModal31').click();
      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
  // ..................................................................SaveOrUpdateServiceGrpMap..................................
  SaveOrUpdateServiceGrpMap(save) {
    this.isSaveorUpdateBoolean=true;
    if (this.ModalType == 'new') {
      this.ServiceGroupMapping.id = '00000000-0000-0000-0000-000000000000';
    }
    let data = JSON.parse(JSON.stringify(save))
    let savedata = {
      "serviceGroupId": save.serviceGroupId,
      "masterServiceIds": save.masterServiceId.map(e => parseInt(e)),
    }
    data.masterServiceId = data.masterServiceId.map(e => parseInt(e));
    let url = "api/ServiceGroup/updateServiceGroupMaps";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(savedata, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.valuchangesServiceGrpMap();
      this.isSaveorUpdateBoolean=false;
      if (this.ModalType == 'new') {
        this.toastrService.success('Group & Service Mapped successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.getServcegroupMap();
        this.ServiceGroupMappingForm.reset();
        document.getElementById('openModal32').click();
      }
      else {
        this.toastrService.success('Group & Service Mapping updated successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.getServcegroupMap();
        document.getElementById('openModal32').click();
      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
  // ..................................................................SaveOrUpdateService..................................
  SaveOrUpdateService() {
    this.isSaveorUpdateBoolean=true;
    if (this.ModalType == 'new') {
      this.Service.id = '00000000-0000-0000-0000-000000000000';
    }
    this.Service.billingLid = null;
    this.Service.statusLid = this.Service.statusLid;
    this.Service.ratio = parseInt(this.Service.ratio.toString());
    this.Service.serviceTypeLid =this.Service.serviceTypeLid
    let url = "api/Service/SaveMasterService";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.Service, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.isSaveorUpdateBoolean=false;
      if (data) {
        this.valueschangesService();
        if (this.ModalType == 'new') {
          this.toastrService.success('Service saved successfully!');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          this.getService();
          document.getElementById('openModal').click();
        } else {
          this.toastrService.success('Service updated successfully!');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          this.getService();
          document.getElementById('openModal').click();
        }
      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
  // ..................................................................SaveOrUpdateActivity..................................
  SaveOrUpdateActivity() {
    this.isSaveorUpdateBoolean=true;
    if (this.ModalType == 'new') {
      this.Activity.id = '00000000-0000-0000-0000-000000000000';
    }
    this.Activity.statusLid = this.Activity.statusLid;
    let url = "api/Activity/SaveMasterActivity";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.Activity, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.isSaveorUpdateBoolean=false;
      if (data) {
        this.valuchangesActivity();
        //====================== sucess message =============
        if (this.ModalType == 'new') {
          this.toastrService.success('Activity saved successfully!');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          this.getActivity();
          document.getElementById('openModal1').click();
        } else {
          this.toastrService.success('Activity updated successfully!');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          this.getActivity();
          document.getElementById('openModal1').click();
        }
      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
  // ..................................................................SaveOrUpdateServiceActivity..................................
  SaveOrUpdateServiceActivity(ServiceActivityArray1) {
    this.isSaveorUpdateBoolean=true
    ServiceActivityArray1.masterServiceId = Math.floor(Number(ServiceActivityArray1.masterServiceId));
    if (this.selectedActivities.length != 0) {
      this.selectedActivities.forEach(element => {
        element.masterServiceId = ServiceActivityArray1.masterServiceId,
          element.id = 0,
          element.masterActivityId = element.Key,

          element.index = this.selectedActivities.indexOf(element) + 1
      })
    }
    else {
      this.selectedActivities.push({
        masterServiceId: ServiceActivityArray1.masterServiceId
      })
    }
    let url = "api/ServiceActivity/saveServiceActivity";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.selectedActivities, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateBoolean=false
      if (data) {
        this.valuchangesServiceActivity();
        if (this.ModalType == 'new') {
          this.toastrService.success('ServiceActivity saved successfully!');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          document.getElementById('openModal2').click();
        } else {
          this.toastrService.success('ServiceActivity updated successfully!');
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
          document.getElementById('openModal2').click();
        }
        this.getServiceActivity();
      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
  // ..................................................................deleteServiceGroup..................................
  deleteServiceGroup() {
    let url = "api/ServiceGroup/DeleteServiceGroup/"
    this.CommonAPI.DeleteFunctionForDeleteHttp(this.ServiceGroup.id, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data) {
        document.getElementById('deleteServiceGroupmodalOpen').click();
        this.toastrService.success('Service Group deleted successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.getServiceGroup();
      }
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    }
    );
  }
  // ..................................................................deleteStatus..................................
  deleteStatus() {
    let url = "api/Service/DeleteMasterService/"
    this.CommonAPI.DeleteFunctionForDeleteHttp(this.Service.id, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data) {
        document.getElementById('deleteservicemodal').click();
        this.toastrService.success('Service deleted successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.getService();
      }
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    }
    );
  }
  // ..................................................................deleteActivity..................................
  deleteActivity() {
    let url = "api/Activity/DeleteMasterActivity/"
    this.CommonAPI.DeleteFunctionForDeleteHttp(this.Activity.id, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data) {
        document.getElementById('closedeleteactivity').click();
        this.toastrService.success('Activity deleted successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.getActivity();
      }
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    }
    );
  }
  // ..................................................................deletePaylocity..................................
  deletePaylocity() {
    let url = "api/Paylocity/DeletePaylocity/"
    this.CommonAPI.DeleteFunctionForDeleteHttp(this.paylocity.id, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data) {
        document.getElementById('closedeletepaylocity').click();
        this.toastrService.success('Paylocity deleted successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.getPaylocity();
      }

    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    }
    );
  }
  // ..................................................................deleteSVCGRP..................................
  deleteSVCGRP() {
    let url = "api/ServiceGroup/deleteGroupServiceMaps/"
    this.CommonAPI.DeleteFunctionForDeleteHttp(this.ServiceGroupMapping.id, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data) {
        document.getElementById('closedeleteServiceGroupMapping').click();
        this.toastrService.success('Group Service mapping deleted successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.getServcegroupMap();
      }

    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    }
    );
  }
  // ..................................................................Drag and Drop..................................
  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }
  // ..................................................................filepermissionget..................................
  filepermissionget() {
    let params = new URLSearchParams();
    params.append("pagecode", "ManageServices");
    //params.append("roleId", this.global.roleId);
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: functionpermission) => {
      this.fp = data;
    });
  }
  // ..................................................................valueschangesServiceGroup..................................
  valueschangesServiceGroup() {
    this.ServiceGroupBool = false;
  }
  // ..................................................................valueschangesService..................................
  valueschangesService() {
    this.valuechangeService = {
      Code: 0,
      Modifier1: 0,
      Modifier2: 0,
      Modifier3: 0,
      Modifier4: 0,
      Name: 0,
      Description: 0,
      BillingUnit: 0,
      Status: 0,
      Ratio: 0,
    }
  }
  // ..................................................................valuchangesActivity..................................
  valuchangesActivity() {
    this.ActivityBool = false;
  }
  // ..................................................................checkpopServiceGroup..................................
  checkpopServiceGroup() {
    this.ServiceGroupBool = true;
  }
  // ..................................................................checkpopServicePaylocity..................................
  checkpopServicePaylocity() {
    this.ServicePalocityBool = true;
  }
  // ..................................................................checkpopServiceGRPMap..................................
  checkpopServiceGRPMap() {
    this.ServiceGrpMapBool = true;
  }
  // ..................................................................checkpopActivity..................................
  checkpopActivity() {
    this.ActivityBool = true;
  }
  // ..................................................................valuchangesServiceActivity..................................
  valuchangesServiceActivity() {
    this.ServiceActivityBool = false;
  }
  // ..................................................................valuchangesServicePaylocity..................................
  valuchangesServicePaylocity() {
    this.ServicePalocityBool = false;
  }
  // ..................................................................valuchangesServiceGrpMap..................................
  valuchangesServiceGrpMap() {
    this.ServiceGrpMapBool = false;
  }
  // ..................................................................checkpopServiceActivity..................................
  checkpopServiceActivity() {
    this.ServiceActivityBool = true;
  }
  // ..................................................................checkpopupService..................................
  checkpopupService(value) {
    if (value == "Code") {
      this.valuechangeService.Code++;
    }
    if (value == "Modifier1") {
      this.valuechangeService.Modifier1++;
    }
    if (value == "Modifier2") {
      this.valuechangeService.Modifier2++;
    } if (value == "Modifier3") {
      this.valuechangeService.Modifier3++;
    } if (value == "Modifier4") {
      this.valuechangeService.Modifier4++;
    } if (value == "Name") {
      this.valuechangeService.Name++;
    } if (value == "Description") {
      this.valuechangeService.Description++;
    } if (value == "BillingUnit") {
      this.valuechangeService.BillingUnit++;
    } if (value == "Status") {
      this.valuechangeService.Status++;
    }
    if (value == "NetRate") {
      this.valuechangeService.NetRate++;
    }
    if (value == "UnitRate") {
      this.valuechangeService.UnitRate++;
    }
    if (value == "Ratio") {
      this.valuechangeService.Ratio++;
    }
    if (value == "isHousing") {
      this.valuechangeService.isHousing++;
    }

  }
  // ..................................................................openDialogServiceGroup..................................
  openDialogServiceGroup() {
    if (this.ServiceGroupBool == true) {
      document.getElementById('cancelmodal').click();
    }
    else {
      // this.ServiceForm.markAsValid;
      // this.ServiceForm.markAsPristine;
      document.getElementById('openModal3').click();
    }
  }
  // ..................................................................openDialogServicePaylocity..................................
  openDialogServicePaylocity() {
    if (this.ServicePalocityBool == true) {
      document.getElementById('cancelmodal').click();
    }
    else {
      document.getElementById('openModal31').click();
      this.PaylocityForm.reset();
    }
  }
  // ..................................................................openDialogServiceGrpMap..................................
  openDialogServiceGrpMap() {
    if (this.ServiceGrpMapBool == true) {
      document.getElementById('cancelmodal').click();
    }
    else {
      document.getElementById('openModal32').click();
      this.ServiceGroupMappingForm.reset();
    }

  }
  // ..................................................................openDialogService..................................
  openDialogService() {
    if (this.valuechangeService.Code > 1 || this.valuechangeService.Modifier1 > 1 || this.valuechangeService.Modifier2 > 1
      || this.valuechangeService.Modifier3 > 1 || this.valuechangeService.Modifier4 > 1 || this.valuechangeService.Name > 1
      || this.valuechangeService.Description > 1 || this.valuechangeService.BillingUnit > 1 || this.valuechangeService.Status > 1 || this.valuechangeService.Ratio > 1
    ) {
      document.getElementById('cancelmodal').click();
    }
    else {
      // this.ServiceForm.markAsValid;
      // this.ServiceForm.markAsPristine;
      document.getElementById('openModal').click();
    }
  }
  // ..................................................................openDialogActivity..................................
  openDialogActivity() {
    if (this.ActivityBool == true) {
      document.getElementById('cancelmodal').click();
    }
    else {
      // this.ServiceForm.markAsValid;
      // this.ServiceForm.markAsPristine;
      document.getElementById('openModal1').click();
    }
  }
  // ..................................................................openDialogServiceActivity..................................
  openDialogServiceActivity() {
    if (this.ServiceActivityBool == true) {
      document.getElementById('cancelmodal').click();
    }
    else {
      // this.ServiceForm.markAsValid;
      // this.ServiceForm.markAsPristine;
      document.getElementById('openModal2').click();
    }
  }
  // ..................................................................closeAddUpdateModal..................................
  closeAddUpdateModal() {
    // this.ServiceForm.markAsPristine;
    // this.ServiceForm.markAsValid;
    document.getElementById('cancelmodal').click();
    if (this.selectedtab == 'Service') {
      document.getElementById('openModal').click();
    }
    if (this.selectedtab == 'Activity') {
      document.getElementById('openModal1').click();
    }
    if (this.selectedtab == 'Serviceactivity') {
      document.getElementById('openModal2').click();
    }
    if (this.selectedtab == 'ServiceGroup') {
      document.getElementById('openModal3').click();
    }
    if (this.selectedtab == 'ServicePaylocity') {
      document.getElementById('openModal31').click();
      this.PaylocityForm.reset();
    }
    if (this.selectedtab == 'ServiceGrpMap') {
      document.getElementById('openModal32').click();
      this.ServiceGroupMappingForm.reset();
    }
  }
  //============================== Tooltip =========================================================//
  headerCellInfo(args) {

    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);

  }
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString(),
          position: 'RightCenter',


        }, args.cell as HTMLTableCellElement);
      }
    }
  }
  // ..................................................................selecttab..................................
  selecttab(val) {
    this.selectedtab = val;
   
  }
  // ..................................................................Applyfilter..................................
  Applyfilter() {
    this.SGsendBO.groupId = this.groupId;
    this.getServcegroupMap();
  }
  // ..................................................................onResize..................................
  onResize(args) {
    if (this.ColumnArray_service != null && this.ColumnArray_service != undefined) {
      const column = this.grid.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray_service.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }

      });
    //  this.SaveColumnwidth();
    }
  }
  onResizeActivity(args) {
    if (this.ColumnArray_activity != null && this.ColumnArray_activity != undefined) {
      const column = this.gridactivity.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray_activity.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }

      });
     // this.SaveColumnwidth();
    }
  }
  onResizeServiceActivity(args) {
    if (this.ColumnArray_serviceactivity != null && this.ColumnArray_serviceactivity != undefined) {
      const column = this.gridserviceactivity.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray_serviceactivity.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }

      });
     // this.SaveColumnwidth();
    }
  }
  // ..................................................................getColumnwidth..................................
 
  // ..................................................................GetDefaultServicesDropDown..................................
  GetDefaultServicesDropDown() {
    let url = "api/ServiceGroup/GetDefaultServicesDropDown?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.defaultServicesDropdown = data;
      this.defaultServicesDropdown.forEach(element => {
        element.Value = element.masterservice.toString();
        element.Key = element.id.toString();
      });
    })
  }
  // ..................................................................GetDefaultServicesDropDown1..................................
  GetDefaultServicesDropDown1() {
    let url = "api/Service/getCommonServicedropdown?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.defaultServicesDropdown1 = data;
      this.GetQpService();
      this.defaultServicesDropdown1.forEach(element => {
        element.Value = element.masterservice.toString();
        element.Key = element.id.toString();
      });
    })
  }
  // ..................................................................GetQpService..................................
  GetQpService() {
    let url = "api/QpServices/getQpServiceIds?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.QpServicesList.masterServiceId = data.map(s => s.toString());
    })
  }
  // ..................................................................GetServiceGroupDropDown..................................
  GetServiceGroupDropDown() {
    let url = 'api/ServiceGroup/GetServiceGroupDrop?'
    this.CommonAPI.RefreshDropDownList('ServiceGroup', "", url, "ServiceDropDown").then((data: any) => {
      this.ServiceGroupDrop = data;
    })
  }
  // ..................................................................checkalnum..................................
  refreshtoGetDropdownValues(ListCode: string) {
    let url = 'api/LOV/getLovDropDown?'
    let params = new URLSearchParams();
    params.append("Code", ListCode);
    if (ListCode == 'Service_Group') {
      let urls = 'api/ServiceGroup/GetServiceGroupDrop?'
      this.CommonAPI.RefreshDropDownList('ServiceGroup', "", urls, "ServiceDropDown").then((data: any) => {
        this.ServiceGroupDrop = data;
      })
    }
    if (ListCode == 'SERVICETYPE') {
      this.CommonAPI.RefreshDropDownList(ListCode, params, url, "LovDropDown").then((data: any) => {
     //   this.global.serviceType = data;
      })
    }
    if (ListCode == 'STATUS') {
      this.CommonAPI.RefreshDropDownList(ListCode, params, url, "LovDropDown").then((data: any) => {
        this.StatusList = data;
      })
    }
    if (ListCode == 'Service_Dropdown') {
      let urlsg = 'api/ServiceGroup/GetServiceGroupDropDown?'
      this.CommonAPI.RefreshDropDownList('ServiceGroupDropDown', "", urlsg, "SDD").then((data: any) => {
        this.ServiceActivityArray = data;
        this.ServiceActivityArray.forEach(element => {
          element.label = element.name;
          element.value = element.id.toString();
        })
      });
    }
  }
  // ..................................................................checkalnum..................................
  checkalnum(event) {
    if (!this.global.isalnum(event.key)) {
      event.preventDefault();
    }
  }
  // ..................................................................getServiceGroupMapping..................................
  getServiceGroupMapping() {
    this.getServcegroupMap();
  }
  // ..................................................................ClearServiceGroupMappingModal..................................
  ClearServiceGroupMappingModal() {
    document.getElementById("openModal32").click();
    this.ServiceGroupMappingForm.reset();
  }
  // ..................................................................ServicePaylocityClear..................................
  ServicePaylocityClear() {
    document.getElementById("openModal31").click();
    this.PaylocityForm.reset();
  }
  // ..................................................................closeErrormodal..................................
  closeErrormodal() {
    document.getElementById('openErrorModal').click();
  }
  // ..................................................................checkAssignQpServicePaylocal..................................
  checkAssignQpServicePaylocal() {
    this.AssignQpSerBool = true;
  }
  // ..................................................................createNewQPService..................................
  createNewQPService(type: string) {
    if (type = 'new') {
      this.ModalType = 'new'
      this.QPServiceForm.reset()
    }
    this.GetQpService();
  }
  // ..................................................................SaveQpService..................................
  SaveQpService() {
    this.isSaveorUpdateBoolean=true;
    this.QpServicesList.masterServiceId = this.QpServicesList.masterServiceId.map(p => parseInt(p));
    let url = "api/QpServices/updateQpServices";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.QpServicesList, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.isSaveorUpdateBoolean=false;
      if (data) {
        this.toastrService.success('Service saved successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
      document.getElementById('OpenAssignQpModel').click();
    }),(err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    }
    
  }
  // ..................................................................closeQPService..................................
  closeQPService() {
    if (this.AssignQpSerBool = true) {
      document.getElementById('OpenAssignQpModel').click();

    } else {
      document.getElementById(' cancelmodal').click();
    }
  }
  getServiceType() {
    let url = 'api/LOV/getLovDropDown?'
    let params = new URLSearchParams();
    params.append("Code", "SERVICETYPE");
    this.CommonAPI.getDropDownList("SERVICETYPE", params, url, "LovDropDown").then((data: any) => {
   //   this.global.serviceType = data;
    })
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
